import "./PolicyModal.scss";

import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { ModalContainer } from "@amzn/stencil-react-components/dist/submodules/modal/ModalContainer";
import { Row, View } from "@amzn/stencil-react-components/layout";
import { ModalBody, ModalFooter, ModalHeader } from "@amzn/stencil-react-components/modal";
import { H2 } from "@amzn/stencil-react-components/text";
import { trackUxmCustomEvent } from "common/helpers/analytics-helper";
import { COOKIE_NAMES, setCookie } from "common/helpers/cookie-utils";
import { getString } from "common/uistringlabels/uiStringUtils";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

export interface PolicyModalProps {
  close: () => void;
  policy: string;
  policyTitle: string;
  policyType: string;
  shouldHaveBackButton?: boolean;
  shouldHaveAcknowledgeButton?: boolean;
  shouldHaveDismissButton?: boolean;
}

export const PolicyModal: FC<PolicyModalProps> = ({
  close,
  policy,
  policyTitle,
  policyType,
  shouldHaveBackButton = false,
  shouldHaveAcknowledgeButton = true,
  shouldHaveDismissButton = false,
}) => {
  const history = useHistory();
  const handleAcknowledge = () => {
    trackUxmCustomEvent("policy_acknowledge", { "policy-type": policyType });
    setCookie(COOKIE_NAMES.AI_POLICY_ACKNOWLEDGED, "true", 365);
    close();
  };

  const handleBack = () => {
    history.push("/");
  };
  return (
    <ModalContainer maxWidth="600px">
      <ModalHeader onCloseButtonClick={shouldHaveDismissButton ? close : undefined}>
        <H2>{policyTitle}</H2>
      </ModalHeader>
      <ModalBody>
        <View>
          <div dangerouslySetInnerHTML={{ __html: policy }} className="policy-modal-message"></div>
        </View>
      </ModalBody>
      <ModalFooter>
        <Row padding={{ bottom: "S300" }} gridGap="S300">
          {shouldHaveBackButton && (
            <Button variant={ButtonVariant.Secondary} onClick={handleBack}>
              {getString("policy.back")}
            </Button>
          )}
          {shouldHaveAcknowledgeButton && (
            <Button variant={ButtonVariant.Primary} onClick={handleAcknowledge} data-cy="policy-acknowledge">
              {getString("policy.acknowledge")}
            </Button>
          )}
        </Row>
      </ModalFooter>
    </ModalContainer>
  );
};
